export default __webpack_public_path__ + "static/media/fleetnexis-logo.d82a20f7.png";